import { Accordion } from "react-bootstrap";
import { Card, CardHeader } from "reactstrap";
import { CoursesListDisplayType } from "../../../../models/coursesListDisplayType";
import { ModuleDto } from "../../../../models/moduleDto";
import CourseList from "../course/course";
import styles from "./modulesListOverview.module.scss";

const ModulesListOverview: React.FC<{
  modules: ModuleDto[];
}> = props => {
  const changeClassName = async (id: any) => {
    let arrayList = document.getElementsByClassName("fa fa-chevron-down toggleArrow");
    for (let i = 0; i < arrayList.length; i++) {
      if (arrayList[i].id !== id) {
        arrayList[i].className = "fa fa-chevron-up toggleArrow";
      }
    }
  };

  const titleClicked = (id: string) => {
    changeClassName(id);
    let e = document.getElementById(id);
    if (e?.className === "fa fa-chevron-down toggleArrow") {
      e.className = "fa fa-chevron-up toggleArrow";
    } else if (e?.className === "fa fa-chevron-up toggleArrow") {
      e.className = "fa fa-chevron-down toggleArrow";
    }
  };

  return (
    <Accordion>
      {props.modules.map((module, index) => {
        return (
          <Card key={index}>
            <CardHeader className="bg-primary" id={styles["addCardHeader"]}>
              <h3 className="mb-0">
                <Accordion.Toggle id={styles["blackpolice"]} className="btn txt-white" color="primary" eventKey={`${index}`} onClick={() => titleClicked(`toggleArrow${module.id}`)}>
                  {module.title}
                  <p className={styles["duration_div"]}>{module.moduleDuration}</p>
                </Accordion.Toggle>
              </h3>
            </CardHeader>
            <Accordion.Collapse eventKey={`${index}`}>
              <CourseList key={module.id} coursesListDisplayType={CoursesListDisplayType.TIMELINE} moduleId={module.id} isTrainingPathUpdate={true} />
            </Accordion.Collapse>
          </Card>
        );
      })}
    </Accordion>
  );
};

export default ModulesListOverview;
